import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import DeepCleaning_Section1 from "./sections/DeepCleaning_Section1";

function DeepCleaning() {
  usePageMeta({
    title: "Deep Cleaning Services Ireland | Spechs",
    description: "Thorough deep cleaning services for homes and businesses across Ireland.",
    canonical: "https://www.spechs.ie/cleaning/deep-cleaning/",
  });
  return (
    <SubPageLayout title="Deep Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <DeepCleaning_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default DeepCleaning;
